module.exports = __webpack_public_path__ + "static/img/bg-tr.280b783a.png";